import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../utils';

const cfg = getConfig();
const FREEAGENT_CLIENT_ID = cfg.FREEAGENT_CLIENT_ID || 'MJSwt0abRcBfW6aV3BCxmA';
const CALLBACK_URL = cfg.FREEAGENT_CALLBACK_URL || 'http://localhost:3001/login';

export default function Login() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const codeMatch = window.location.href.match(/code=([^&]+)/);
    if (codeMatch) {
      localStorage.setItem('auth_code', codeMatch[1]);
      localStorage.setItem('callbackUrl', CALLBACK_URL);
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/secure');
    }
  }, [isLoggedIn, navigate]);

  const handleLogin = () => {
    const target = `https://api.freeagent.com/v2/approve_app?scope=jack&redirect_uri=${encodeURIComponent(
      CALLBACK_URL
    )}&response_type=code&client_id=${FREEAGENT_CLIENT_ID}&access_type=offline`;
    window.location.href = target;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-sm rounded-xl bg-white p-8 shadow-lg">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-900">
            <svg className="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h1 className="text-xl font-bold text-slate-900">FreeAgent Reporting</h1>
          <p className="mt-1 text-sm text-slate-600">
            Connect your FreeAgent account to view reports
          </p>
        </div>
        <button
          onClick={handleLogin}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 py-3 text-sm font-semibold text-white shadow-md transition-colors hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
          </svg>
          Sign in with FreeAgent
        </button>
      </div>
    </div>
  );
}
